import React from "react";

function ComingSoon() {
    return (
        <div className="container">
            <h2>Coming Soon</h2>
            <p>Stay tuned for updates!</p>
        </div>
    );
}

export default ComingSoon;
